export default __webpack_public_path__ + "static/media/toast-success.3e1647de.svg";